export const houseTypeCard = {
  satrtDesign: '开始设计'
};
